var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Body } from '@lendi-ui/typography';
import { pt } from '@lendi-ui/spacing';
import { BaseAvatar } from '../style';
import { bg } from '@lendi-ui/color';
export var CustomerWrapper = styled(BaseAvatar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  ", " {\n    ", ";\n  }\n\n  ", ";\n"], ["\n  ", ";\n\n  ", " {\n    ", ";\n  }\n\n  ", ";\n"])), bg('secondary.400'), Body, pt('xxs'), function (_a) {
    var isFooter = _a.isFooter;
    return isFooter &&
        "\n    margin-left: 2px;\n  ";
});
export var CustomerBody = styled(Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-top: 0 !important; // Override LUI's body padding attribute to fix the tiny avator circle\n  ", ";\n"], ["\n  padding-top: 0 !important; // Override LUI's body padding attribute to fix the tiny avator circle\n  ", ";\n"])), function (_a) {
    var isFooter = _a.isFooter;
    return (isFooter ? 'margin-top: -6px;' : 'margin-top: -2px;');
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=style.js.map